{"name": "nextgen-bitbrew-web", "buildversion": "1.0.14_11032026-160546", "buildTime": "03/11/2026 16:05:46"}